import React, { FC, useCallback, useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useReactiveVar } from '@apollo/client'

import { NavTabs } from 'modulesCommon/Navigation/components'
import { activeGlobalProjectTabVar, activeProjectTabVar } from 'modules/Projects/store'
import { projectFeedTotalVar } from 'modulesCommon/store'
import { globalizeProjectDetailsNavTabs } from 'modules/Globalize/utils'
import { useTour } from 'modules/TourDates/serviceHooks/useTour'
import { TRouterParams } from 'shared/types'
import useGetSuccessStories from '../../../GlobalProject/serviceHooks/useGetSuccessStories'

const GlobalizedProjectNavTabs: FC = () => {
  const { pathname, state } = useLocation()
  const { id } = useParams<TRouterParams>()

  const activeProjectTab = useReactiveVar(activeGlobalProjectTabVar)
  const projectFeedTotal = useReactiveVar(projectFeedTotalVar)

  const { total } = useTour(id)
  const { successStoriesTotal } = useGetSuccessStories()

  useEffect(() => {
    // TODO: state.tab - if we need to navigato to some exact tab
    activeGlobalProjectTabVar(state?.tab || 'stories')
    activeProjectTabVar(state?.tab || 'stories')
  }, [pathname, state])

  const handleActive = useCallback((tab: string) => {
    activeGlobalProjectTabVar(tab)
    activeProjectTabVar(tab)
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }, [])

  return (
    <NavTabs
      navs={globalizeProjectDetailsNavTabs(projectFeedTotal, total, successStoriesTotal)}
      setActiveTab={handleActive}
      activeTab={activeProjectTab}
    />
  )
}

export default GlobalizedProjectNavTabs
